/**
 *
 * @param {WindowCoordinatesProps} pointer
 * @param {Number} dimension
 * @param {"x" | "y"} axis
 * @returns
 */
const getPointerParallaxPercents = (pointer, dimension, axis) => {
  const pointerValue = /** @type {Number} */ (pointer.get(axis));
  return (pointerValue - dimension / 2) / (dimension / 2);
};

export default getPointerParallaxPercents;
